export default __webpack_public_path__ + "static/media/ln.c47387bc.svg";